import type { MealItem } from './types'

export function normalizeDishHtml(dishHtml: string): string {
  return dishHtml
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .trim()
}

export function parseMealItems(dishHtml: string): MealItem[] {
  const text = normalizeDishHtml(dishHtml)
  if (!text) return []

  const lines = text
    .split('\n')
    .map((s) => s.trim())
    .filter(Boolean)

  return lines.map(parseLine)
}

function parseLine(line: string): MealItem {
  const allergyMatches = [...line.matchAll(/\((\s*\d+(?:\s*\.\s*\d+)*\s*)\)/g)]
  const last = allergyMatches.at(-1)
  if (!last) return { name: cleanupName(line), allergies: [] }

  const inside = last[1]
  const allergies = inside
    .split('.')
    .map((s) => Number(s.trim()))
    .filter((n) => Number.isFinite(n))

  const withoutAllergy = line.slice(0, last.index).trim()
  return { name: cleanupName(withoutAllergy), allergies }
}

function cleanupName(name: string): string {
  return name
    .replace(/\s+/g, ' ')
    .replace(/\u200b/g, '')
    .trim()
}
